import React from 'react';

const File = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
  >
    <path
      d="M4.76562 0C3.94063 0 3.26562 0.675 3.26562 1.5V22.5C3.26562 23.325 3.94063 24 4.76562 24H19.7656C20.5906 24 21.2656 23.325 21.2656 22.5V6L15.2656 0H4.76562Z"
      fill="#DCE0DA"
    />
    <path
      d="M16.7656 6H21.2656L15.2656 0V4.5C15.2656 5.325 15.9406 6 16.7656 6Z"
      fill="#1D211A"
    />
    <path d="M21.2656 10.5L16.7656 6H21.2656V10.5Z" fill="#BFC4BA" />
    <path
      d="M18.2656 19.5C18.2656 19.9125 17.9281 20.25 17.5156 20.25H1.01562C0.603125 20.25 0.265625 19.9125 0.265625 19.5V12C0.265625 11.5875 0.603125 11.25 1.01562 11.25H17.5156C17.9281 11.25 18.2656 11.5875 18.2656 12V19.5Z"
      fill="#378906"
    />
    <path
      d="M17.5156 20.25H3.26562V21H17.5156C17.9281 21 18.2656 20.6625 18.2656 20.25V19.5C18.2656 19.9125 17.9281 20.25 17.5156 20.25Z"
      fill="#D1D8CD"
    />
  </svg>
);

export default File;
